import {z} from "zod";

const defaultApiUrl = import.meta.env.PROD ? "/api" : "http://localhost:5000";
const defaultWpRegistrationUrl = import.meta.env.PROD
  ? "https://chaykastudia.ru/wp-login.php?action=register"
  : "https://dev.pollas.ru/wp-login.php?action=register";

const isRootRelativePath = (value: string) => {
  return value.startsWith("/");
};

const isAbsoluteUrl = (value: string) => {
  return z.string().url().safeParse(value).success;
};

const envSchema = z.object({
  VITE_API_URL: z
    .string()
    .min(1)
    .refine((value) => isRootRelativePath(value) || isAbsoluteUrl(value), {
      message: "VITE_API_URL must be an absolute URL or a root-relative path",
    })
    .default(defaultApiUrl),
  VITE_WP_REGISTRATION_URL: z
    .string()
    .url("VITE_WP_REGISTRATION_URL must be an absolute URL")
    .default(defaultWpRegistrationUrl),
});

const isLocalHostname = (hostname: string) => {
  return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "0.0.0.0";
};

const parsedEnv = envSchema.parse(import.meta.env);
const normalizedApiUrl =
  parsedEnv.VITE_API_URL === "/" ? "" : parsedEnv.VITE_API_URL.replace(/\/+$/, "");

if (import.meta.env.PROD && typeof window !== "undefined") {
  if (isAbsoluteUrl(normalizedApiUrl)) {
    const appOrigin = window.location.origin;
    const apiOrigin = new URL(normalizedApiUrl).origin;
    const apiHostname = new URL(normalizedApiUrl).hostname;

    if (appOrigin !== apiOrigin) {
      console.warn(
        "[env] Production bundle is using a cross-origin API URL. Use VITE_API_URL=/api with the web rewrite to keep auth same-origin.",
        {
          appOrigin,
          apiUrl: normalizedApiUrl,
        },
      );
    }

    if (!isLocalHostname(window.location.hostname) && isLocalHostname(apiHostname)) {
      console.error(
        "[env] Production bundle is configured to use a localhost API URL. Set VITE_API_URL to /api or to the deployed API origin during the web build.",
        {
          appOrigin,
          apiUrl: normalizedApiUrl,
        },
      );
    }
  }
}

export const env = {
  ...parsedEnv,
  VITE_API_URL: normalizedApiUrl,
};
